function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {

   // Skip product accordions - they have their own handler
    if (summary.closest('.product__accordion.accordion') || summary.closest('.product__accordion_need_to_know')) {
      return;
    }
  
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling && summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
       document.body.classList.add('checkout_btn_load');
const previousValue = Number(this.input.value);
const maxVal = Number(this.input.dataset.maxi);
const quantityInputParent = this.input.closest('quantity-input');


  







      if (event.target.name === 'plus') {
         if (quantityInputParent) {
          quantityInputParent.classList.add('js-item-add');
}
//alert(maxVal + ' ' + previousValue);
    if (previousValue >= maxVal) {
      if (window.location.pathname === '/cart') {
 document.querySelector('.error_display_text').innerHTML = 'Maximum limit reached for this product.';
      document.querySelector('.error_display').classList.add('active');
  } else {
document.querySelector('.error-text-icon p').innerHTML = 'Maximum limit reached for this product.';
      document.querySelector('.error-redeem-points').classList.add('active');
      const cartItemsContainer = document.querySelector('.cart-drawer cart-drawer-items');

      cartItemsContainer.scrollTo({
  top: 0,
  behavior: 'smooth'
});
 
    }
             if (quantityInputParent) {
  quantityInputParent.classList.remove('js-item-add');
}
      return;
    }
if (
  event.target.getAttribute('cartvalue') === 'redeem'
) {

const redeemCountElement = document.querySelector('#draw-redeem-count');
const redeemCount = redeemCountElement ? Number(redeemCountElement.textContent.trim()) : 0;
      const maxValues = parseInt(redeemCountElement.dataset.max, 10);
  const cartPoints = parseInt(event.target.getAttribute('productpoints'), 10);
          const availableP = Number(document.getElementById("kctp").textContent);
      if (redeemCount >= maxValues) {

        if (window.location.pathname === '/cart') {
 document.querySelector('.error_display_text').innerHTML = 'Maximum redeem count reached.';
      document.querySelector('.error_display').classList.add('active');
  } else {
        document.querySelector('.error-text-icon p').innerHTML = 'Maximum redeem count reached.';
      document.querySelector('.error-redeem-points').classList.add('active');
      const cartItemsContainer = document.querySelector('.cart-drawer cart-drawer-items');
      cartItemsContainer.scrollTo({
  top: 0,
  behavior: 'smooth'
});

        }
                        if (quantityInputParent) {
  quantityInputParent.classList.remove('js-item-add');
}
          return;
} else if (availableP < cartPoints) {
      if (window.location.pathname === '/cart') {
 document.querySelector('.error_display_text').innerHTML = 'Unfortunately you do not have enough Circle Points to redeem this product';
      document.querySelector('.error_display').classList.add('active');
  } else {   
 document.querySelector('.error-text-icon p').innerHTML = 'Unfortunately you do not have enough Circle Points to redeem this product';
      document.querySelector('.error-redeem-points').classList.add('active');
      const cartItemsContainer = document.querySelector('.cart-drawer cart-drawer-items');
      cartItemsContainer.scrollTo({
  top: 0,
  behavior: 'smooth'
});


      } 

                        if (quantityInputParent) {
  quantityInputParent.classList.remove('js-item-add');
}
          return;
        
} else {
           if (quantityInputParent) {
  quantityInputParent.classList.add('js-item-add');
}
}

  
}

      
    } else {



        if (
  event.target.getAttribute('cartvalue') === 'ordered'
) {

const redeemCountElement = document.querySelector('#draw-redeem-count');
const redeemCount = redeemCountElement ? Number(redeemCountElement.textContent.trim()) : 0;


      if (redeemCount > 0) {
         if (window.location.pathname === '/cart') {
 document.querySelector('.error_display_text').innerHTML = 'To remove this item, first remove the selected gifts from your basket.';
      document.querySelector('.error_display').classList.add('active');
  } else {  
        document.querySelector('.error-text-icon p').innerHTML = 'To remove this item, first remove the selected gifts from your basket.';
      document.querySelector('.error-redeem-points').classList.add('active');
      const cartItemsContainer = document.querySelector('.cart-drawer cart-drawer-items');
      cartItemsContainer.scrollTo({
  top: 0,
  behavior: 'smooth'
});


      }
                        if (quantityInputParent) {
  quantityInputParent.classList.remove('js-item-add');
}
          return;
} else {
           if (quantityInputParent) {
  quantityInputParent.classList.add('js-item-add');
}
}

  
}

        

    }
    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }



    setTimeout(() => {




    }, 3000);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      // this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }

  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }

  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

// cart drawer js
// Open the popup and add class to the body when cart-icon-bubble button is clicked
document.getElementById('cart-icon-bubble').addEventListener('click', function(event) {
  // Prevent click event from propagating to the document body (to avoid immediate closing)
if (this.classList.contains('temp-cart')) {
    location.reload(); // Reload the page
    return; // Exit the function to prevent further execution
  }
  
  event.stopPropagation();

  // Add the class to the body to open the popup
  document.body.classList.add('menu-open');

  // Pause all video players
  document.querySelectorAll('.video-player').forEach(function(video) {
    video.pause();
  });
});

// Close the popup and remove class from body when clicking outside of the popup
document.addEventListener('click', function(event) {
  // Check if the clicked area is outside of the popup and the cart icon
  if (!event.target.closest('#cart-icon-bubble') && !event.target.closest('.popup-element')) {
    // Remove the class from the body
    document.body.classList.remove('menu-open');

    // Play all video players
    document.querySelectorAll('.video-player').forEach(function(video) {
      video.play();
    });
  }
});

// Prevent closing when clicking inside the popup (so the click event does not propagate to the body)
document.querySelectorAll('.popup-element').forEach(function(popup) {
  popup.addEventListener('click', function(event) {
    event.stopPropagation();
  });
});

// Close the popup when Escape key is pressed
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    // Remove the class from the body
    document.body.classList.remove('menu-open');

    // Play all video players
    document.querySelectorAll('.video-player').forEach(function(video) {
      video.play();
    });
  }
});

// end cart drawer js

// logout click then local storage data clear
document.addEventListener('DOMContentLoaded', function () {
    // Logout Button Click
    const logoutButton = document.querySelector('.customer-logout');
    if (logoutButton) {
        logoutButton.addEventListener('click', function () {
            // Remove only the specific customer data from local storage
            if (localStorage.getItem('customerData')) {
                localStorage.removeItem('customerData');
                console.log('Customer data cleared on logout.'); // Debug message
            } else {
                console.log('No customer data found to clear.'); // Debug message
            }
        });
    }
});
// end logout click then local storage data clear


// home page sticky js code
document.addEventListener("DOMContentLoaded", function () {
  const stickySections = document.querySelectorAll(".sticky-section");
  let scrollCounter = 0;

  window.addEventListener("scroll", function () {
    scrollCounter++;
    stickySections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const imageTextWrapper = section.querySelector(".image-text-wrapper");

      if (scrollCounter > 5 && rect.top <= 52) {
        if (imageTextWrapper) {
          imageTextWrapper.classList.add("sticky");
        }
      } else {
        if (imageTextWrapper) {
          imageTextWrapper.classList.remove("sticky");
        }
      }
    });
  });
});
    const updateMiniCartMaster = () => {
      fetch(window.Shopify.routes.root + '?sections=cart-drawer')
        .then((response) => response.json())
        .then((data) => {
          const parser = new DOMParser();
          const newDrawerHTML = parser.parseFromString(data['cart-drawer'], 'text/html');
          const newDrawer = newDrawerHTML.querySelector('cart-drawer');
          const currentDrawer = document.querySelector('cart-drawer');
          if (currentDrawer && newDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
            // Call Flickity initialization after the cart drawer is updated
            initializeFlickity();
           


            document.querySelectorAll('[cart-var-id]').forEach(elmaddc => {
  const varIdsadd = elmaddc.getAttribute('cart-var-id');
  const sectionsadd = elmaddc.getAttribute('cart-section') || '';

  alertVariant(varIdsadd, sectionsadd, 'https://roollapius.korres.com');


});

                     document.querySelectorAll('[mcart-var-id]').forEach(elmainrc => {
  const varIdsadd = elmainrc.getAttribute('mcart-var-id');
  const sectionsadd = elmainrc.getAttribute('cart-section') || '';

  alertVariant(varIdsadd, sectionsadd, 'https://roollapius.korres.com');


});

                document.querySelectorAll('.carousel-cell-fav').forEach(elmaddrc => {
  const varIdsaddr = elmaddrc.getAttribute('data-var-id');

  alertVariant(varIdsaddr, "favorite", 'https://roollapius.korres.com');


});



          }
           document.body.classList.remove('checkout_btn_load');
        });
    };
// cart remove js
document.addEventListener('DOMContentLoaded', function () {
  // Run only on cart page
  if (window.location.pathname === '/cart') {

    const updateMiniCart = () => {
      fetch(window.Shopify.routes.root + '?sections=cart-drawer')
        .then((response) => response.json())
        .then((data) => {
          const parser = new DOMParser();
          const newDrawerHTML = parser.parseFromString(data['cart-drawer'], 'text/html');
          const newDrawer = newDrawerHTML.querySelector('cart-drawer');
          const currentDrawer = document.querySelector('cart-drawer');
          if (currentDrawer && newDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;
            // Call Flickity initialization after the cart drawer is updated
            initializeFlickity();
            redem_progress();
          }
        });
    };

    // Observe for changes in the cart items section
    const cartItems = document.querySelector('cart-items');
    if (cartItems) {
      const observer = new MutationObserver(() => {
        updateMiniCart();
      });

      observer.observe(cartItems, {
        childList: true,
        subtree: true,
      });
    }
  }
});
// end cart remove js


// loyalty circle info sticky js
document.addEventListener("DOMContentLoaded", function () {
  const stickySections = document.querySelectorAll(".loyalty-content");
  let scrollCounter = 0;

  window.addEventListener("scroll", function () {
    scrollCounter++;
    stickySections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const imageTextWrapper = section.querySelector(".loyalty-content-inner");

      if (scrollCounter > 5 && rect.top <= 52) {
        if (imageTextWrapper) {
          imageTextWrapper.classList.add("sticky");
        }
      } else {
        if (imageTextWrapper) {
          imageTextWrapper.classList.remove("sticky");
        }
      }
    });
  });
});

// filter remove js code
document.addEventListener('click', function (e) {
  if (e.target.closest('.selected-filters__remove')) {
    e.preventDefault();

    const button = e.target.closest('.selected-filters__remove');
    const valueToRemove = button.getAttribute('data-value').trim();

    // Sabhi matching checkboxes ko check karo (agar koi ek nahi mila ho to)
    const allCheckboxes = document.querySelectorAll(`input[type="checkbox"][name="${button.getAttribute('data-name')}"]`);

    allCheckboxes.forEach(function (checkbox) {
      const checkboxValue = checkbox.value.trim();

      if (checkboxValue === valueToRemove && checkbox.checked) {
        checkbox.click();

        // Optional: Dispatch change event if necessary
        const changeEvent = new Event('change', { bubbles: true });
        checkbox.dispatchEvent(changeEvent);
      }
    });
  }
});
  var requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

function alertVariant(variantId, page, baseurl) {
  console.log('variantId:', variantId);
  console.log('page:', page);

  const kciElement = document.getElementById('kci');
  const kciValue = kciElement ? kciElement.textContent.trim() : "0";

  // ⭐ When API call is fired
  const apiFireTime = performance.now();
  console.log(
    `🔥 API fired for variant ${variantId} at ${apiFireTime.toFixed(2)}ms | ReadyState: ${document.readyState}`
  );

  const startTime = performance.now(); // Start API timing

  /*fetch(`${baseurl}/api/v1/MarketplaceItem/GetUserCircleDiscountList?id=${kciValue}&variant_id=${variantId}&poi_code=0`, requestOptions)
    .then(response => response.json())
    .then(result => {
      const apiEndTime = performance.now();
      const apiTime = (apiEndTime - startTime).toFixed(2); // API duration

      if (!result.length) return;

      result.forEach((elm, index) => {
        if (index !== 0) return;

        const product_discounted_price = parseFloat(elm.product_discounted_price).toFixed(2);
        const product_actual_price = parseFloat(elm.product_actual_price).toFixed(2);
        const pointsAcq = elm.acquired_points;
        const discountpct = elm.discountpct;
        const redeemPoints = elm.redemption_points;
        const quantity_limit = elm.quantitylimit;
        const maxquantity_sale = elm.maxquantitysale;

        const discountClass = elm.discountvalue > 0 ? 'discountClass' : '';

        if (page === "mainproduct") {
          const discountElements = document.querySelectorAll('.product-discount-point');

          if (elm.discountvalue > 0) {
            if (discountElements.length > 0) {
              discountElements.forEach(el => {
                el.innerHTML = `<span class="discount-point ${discountClass}">-${discountpct}%</span>`;
              });
            } else {
              const productInfoTop = document.querySelector('.product__info-top');
              if (productInfoTop) {
                productInfoTop.insertAdjacentHTML(
                  'beforeend',
                  `<div class="product-discount-point"><span class="discount-point ${discountClass}">-${discountpct}%</span></div>`
                );
              }
            }
          }

          const redeemPointElements = document.querySelectorAll('.redeem_point');
          redeemPointElements.forEach(el => {
            if (redeemPoints) el.textContent = redeemPoints;
          });

          const redeemInputs = document.querySelectorAll(`input.redep[data-cpr-id="${variantId}"]`);
          redeemInputs.forEach(input => {
            if (redeemPoints) input.value = parseFloat(redeemPoints);
          });
        }

        let card;
        if (page.includes('favorite')) {
          card = document.querySelector(`.carousel-cell-fav[data-var-id="${variantId}"]`);
        } else if (page.includes('tab')) {
          card = document.querySelector(`.${page} .product-card-wrapper[data-var-id="${variantId}"]`);
        } else if (page.includes('search')) {
          card = document.querySelector(`#search_result_view .product-card-wrapper[data-var-id="${variantId}"]`);
        } else if (page.includes('mainproduct')) {
          card = document.querySelector(`.product__info-wrapper`);
        } else {
          card = document.querySelector(`.product-card-wrapper[data-var-id="${variantId}"]`);
        }

        const specialSelectors = {
          'drawerredeem': { attr: 'cart-var-id', max: quantity_limit },
          'main-redeem': { attr: 'mcart-var-id', max: quantity_limit },
          'drawerordered': { attr: 'cart-var-id', max: maxquantity_sale },
          'main-ordered': { attr: 'mcart-var-id', max: maxquantity_sale },
        };

        let domTime = 0;
        let matchedSpecial = false;

        for (const key in specialSelectors) {
          if (page.includes(key)) {
            matchedSpecial = true;

            const attrType = specialSelectors[key].attr;
            const maxValue = specialSelectors[key].max;

            const selectorD = `[${attrType}="${variantId}"][cart-section="${page}"] quantity-input input`;
            const selectorLimit = `[${attrType}="${variantId}"][cart-section="${page}"] quantity-input`;

            const input = document.querySelector(selectorD);
            const limitElement = document.querySelector(selectorLimit);

            if (input) input.setAttribute('data-maxi', maxValue);

            if (limitElement) {
              const domStart = performance.now();
              limitElement.classList.remove('js-item-add');
              const domEnd = performance.now();
              domTime = (domEnd - domStart).toFixed(2);

              // ⭐ Time from API fired → class removal
              const totalTimeFromFire = (domEnd - apiFireTime).toFixed(2);
              console.log(
                `🟢 variant ${variantId} → Time from API fire → class removal: ${totalTimeFromFire}ms`
              );
            }

            // Unified timing log
            console.log(`⏱️ variantId ${variantId} | API: ${apiTime}ms | DOM: ${domTime}ms`);
            break;
          }
        }

        // ⭐ Always log timing even if no special selector matched
        if (!matchedSpecial) {
          console.log(`⏱️ variantId ${variantId} | API: ${apiTime}ms | DOM: ${domTime}ms`);
        }

        if (card) {
          const priceEl = card.querySelector('.price__regular .price-item--regular');
          const priceWrap = card.querySelector('.price');
          const saleStrike = card.querySelector('.price__sale .price-item--regular');
          const salePrice = card.querySelector('.price__sale .price-item--sale');
          const redeemPts = card.querySelector('.redeem_point');

          let inputEl, inputAp, inputRedeemp, cartButtons;

          if (page.includes('favorite')) {
            cartButtons = card.querySelector('product-form');
            inputEl = card.querySelector(`input.custompfav[data-cp-id="${variantId}"]`);
            inputAp = card.querySelector(`input.acqpfav[data-cp-id="${variantId}"]`);
          } else {
            cartButtons = page.includes('mainproduct')
              ? card.querySelector('.product__info-container .btn-container')
              : card.querySelector('.quick-add.no-js-hidden');

            inputEl = card.querySelector(`input.customp[data-cp-id="${variantId}"]`);
            inputAp = card.querySelector(`input.acqp[data-cp-id="${variantId}"]`);
            inputRedeemp = card.querySelector(`input.redep[data-cpr-id="${variantId}"]`);
          }

          if (elm.discountvalue > 0) {
            if (page.includes('mainproduct')) {
              const buttonPrices = card.querySelectorAll('.button-price');
              if (buttonPrices) {
                buttonPrices.forEach(button => {
                  button.textContent = `$${product_discounted_price}`;
                });
              }
            }
            if (priceWrap) priceWrap.classList.add('price--on-sale');

            const discountEls = card.querySelectorAll('.product-discount-point');
            if (discountEls.length > 0) {
              discountEls.forEach(el => {
                el.innerHTML = `<span class="discount-point ${discountClass} ">-${discountpct}%</span>`;
              });
            }

            if (saleStrike) saleStrike.textContent = `$${product_actual_price}`;
            if (salePrice) salePrice.textContent = `$${product_discounted_price}`;
            if (inputEl) inputEl.value = parseFloat(product_discounted_price) * 100;

          } else {
            if (page.includes('favorite')) {
              if (inputEl) inputEl.value = parseFloat(product_actual_price) * 100;
            } else {
              if (priceEl) priceEl.textContent = `$${product_actual_price}`;
              if (inputEl) inputEl.value = parseFloat(product_actual_price) * 100;
            }
          }

          if (inputAp && pointsAcq) inputAp.value = parseFloat(pointsAcq);
          if (inputRedeemp && redeemPoints) inputRedeemp.value = parseFloat(redeemPoints);
          if (!page.includes('favorite') && redeemPts) redeemPts.textContent = redeemPoints;

          if (cartButtons) {
            if (page.includes('favorite')) {
              cartButtons.classList.remove('cart-add-js');
            } else {
              cartButtons.classList.remove('js-add-hidden');
            }
          }
        }

      });
    })
    .catch(error => console.error('Error:', error));*/
}
function alertVariant(variantId, page, baseurl) {
  console.log('variantId:', variantId);
  console.log('page:', page);

  const kciElement = document.getElementById('kci');
  const kciValue = kciElement ? kciElement.textContent.trim() : "0";
  console.log("kciValue",kciValue);

  // ⭐ When API call is fired
  const apiFireTime = performance.now();
  console.log(
    `Checker: 🔥 API fired for variant ${variantId} at ${apiFireTime.toFixed(2)}ms | ReadyState: ${document.readyState}`
  );

  const startTime = performance.now(); // Start API timing

  /*fetch(`${baseurl}/api/v1/MarketplaceItem/GetUserCircleDiscountList?id=${kciValue}&variant_id=${variantId}&poi_code=0`, requestOptions)
    .then(response => response.json())
    .then(result => {
      const apiEndTime = performance.now();
      const apiTime = (apiEndTime - startTime).toFixed(2); // API duration

      if (!result.length) return;

      result.forEach((elm, index) => {
        if (index !== 0) return;

        const product_discounted_price = parseFloat(elm.product_discounted_price).toFixed(2);
        const product_actual_price = parseFloat(elm.product_actual_price).toFixed(2);
        const pointsAcq = elm.acquired_points;
        const discountpct = elm.discountpct;
        const redeemPoints = elm.redemption_points;
        const quantity_limit = elm.quantitylimit;
        const maxquantity_sale = elm.maxquantitysale;

        const discountClass = elm.discountvalue > 0 ? 'discountClass' : '';

        if (page === "mainproduct") {
          const discountElements = document.querySelectorAll('.product-discount-point');

          if (elm.discountvalue > 0) {
            if (discountElements.length > 0) {
              discountElements.forEach(el => {
                el.innerHTML = `<span class="discount-point ${discountClass}">-${discountpct}%</span>`;
              });
            } else {
              const productInfoTop = document.querySelector('.product__info-top');
              if (productInfoTop) {
                productInfoTop.insertAdjacentHTML(
                  'beforeend',
                  `<div class="product-discount-point"><span class="discount-point ${discountClass}">-${discountpct}%</span></div>`
                );
              }
            }
          }

          const redeemPointElements = document.querySelectorAll('.redeem_point');
          redeemPointElements.forEach(el => {
            if (redeemPoints) el.textContent = redeemPoints;
          });

          const redeemInputs = document.querySelectorAll(`input.redep[data-cpr-id="${variantId}"]`);
          redeemInputs.forEach(input => {
            if (redeemPoints) input.value = parseFloat(redeemPoints);
          });
        }

        let card;
        if (page.includes('favorite')) {
          card = document.querySelector(`.carousel-cell-fav[data-var-id="${variantId}"]`);
        } else if (page.includes('tab')) {
          card = document.querySelector(`.${page} .product-card-wrapper[data-var-id="${variantId}"]`);
        } else if (page.includes('search')) {
          card = document.querySelector(`#search_result_view .product-card-wrapper[data-var-id="${variantId}"]`);
        } else if (page.includes('mainproduct')) {
          card = document.querySelector(`.product__info-wrapper`);
        } else {
          card = document.querySelector(`.product-card-wrapper[data-var-id="${variantId}"]`);
        }

        const specialSelectors = {
          'drawerredeem': { attr: 'cart-var-id', max: quantity_limit },
          'main-redeem': { attr: 'mcart-var-id', max: quantity_limit },
          'drawerordered': { attr: 'cart-var-id', max: maxquantity_sale },
          'main-ordered': { attr: 'mcart-var-id', max: maxquantity_sale },
        };

        let domTime = 0;
        let matchedSpecial = false;

        for (const key in specialSelectors) {
          if (page.includes(key)) {
            matchedSpecial = true;

            const attrType = specialSelectors[key].attr;
            const maxValue = specialSelectors[key].max;

            const selectorD = `[${attrType}="${variantId}"][cart-section="${page}"] quantity-input input`;
            const selectorLimit = `[${attrType}="${variantId}"][cart-section="${page}"] quantity-input`;

            const input = document.querySelector(selectorD);
            const limitElement = document.querySelector(selectorLimit);

            if (input) input.setAttribute('data-maxi', maxValue);

            if (limitElement) {
              const domStart = performance.now();
              limitElement.classList.remove('js-item-add');
              const domEnd = performance.now();
              domTime = (domEnd - domStart).toFixed(2);

              // ⭐ Time from API fired → class removal
              const totalTimeFromFire = (domEnd - apiFireTime).toFixed(2);
              console.log(
                `Checker: 🟢 variant ${variantId} → Time from API fire → class removal: ${totalTimeFromFire}ms`
              );
            }

            // Unified timing log
            console.log(`Checker: ⏱️ variantId ${variantId} | API: ${apiTime}ms | DOM: ${domTime}ms`);
            break;
          }
        }

        // ⭐ Always log timing even if no special selector matched
        if (!matchedSpecial) {
          console.log(`Checker: ⏱️ variantId ${variantId} | API: ${apiTime}ms | DOM: ${domTime}ms`);
        }

        if (card) {
          const priceEl = card.querySelector('.price__regular .price-item--regular');
          const priceWrap = card.querySelector('.price');
          const saleStrike = card.querySelector('.price__sale .price-item--regular');
          const salePrice = card.querySelector('.price__sale .price-item--sale');
          const redeemPts = card.querySelector('.redeem_point');

          let inputEl, inputAp, inputRedeemp, cartButtons;

          if (page.includes('favorite')) {
            cartButtons = card.querySelector('product-form');
            inputEl = card.querySelector(`input.custompfav[data-cp-id="${variantId}"]`);
            inputAp = card.querySelector(`input.acqpfav[data-cp-id="${variantId}"]`);
          } else {
            cartButtons = page.includes('mainproduct')
              ? card.querySelector('.product__info-container .btn-container')
              : card.querySelector('.quick-add.no-js-hidden');

            inputEl = card.querySelector(`input.customp[data-cp-id="${variantId}"]`);
            inputAp = card.querySelector(`input.acqp[data-cp-id="${variantId}"]`);
            inputRedeemp = card.querySelector(`input.redep[data-cpr-id="${variantId}"]`);
          }

          if (elm.discountvalue > 0) {
            if (page.includes('mainproduct')) {
              const buttonPrices = card.querySelectorAll('.button-price');
              if (buttonPrices) {
                buttonPrices.forEach(button => {
                  button.textContent = `$${product_discounted_price}`;
                });
              }
            }
            if (priceWrap) priceWrap.classList.add('price--on-sale');

            const discountEls = card.querySelectorAll('.product-discount-point');
            if (discountEls.length > 0) {
              discountEls.forEach(el => {
                el.innerHTML = `<span class="discount-point ${discountClass} ">${discountpct}% Off</span>`;
              });
            }

            if (saleStrike) saleStrike.textContent = `$${product_actual_price}`;
            if (salePrice) salePrice.textContent = `$${product_discounted_price}`;
            if (inputEl) inputEl.value = parseFloat(product_discounted_price) * 100;

          } else {
            if (page.includes('favorite')) {
              if (inputEl) inputEl.value = parseFloat(product_actual_price) * 100;
            } else {
              if (priceEl) priceEl.textContent = `$${product_actual_price}`;
              if (inputEl) inputEl.value = parseFloat(product_actual_price) * 100;
            }
          }

          if (inputAp && pointsAcq) inputAp.value = parseFloat(pointsAcq);
          if (inputRedeemp && redeemPoints) inputRedeemp.value = parseFloat(redeemPoints);
          if (!page.includes('favorite') && redeemPts) redeemPts.textContent = redeemPoints;

          if (cartButtons) {
            if (page.includes('favorite')) {
              cartButtons.classList.remove('cart-add-js');
            } else {
              cartButtons.classList.remove('js-add-hidden');
            }
          }
        }

      });
    })
    .catch(error => console.error('Error:', error));*/
}




document.querySelector('.error_display_dismiss').addEventListener('click', function () {
  document.querySelector('.error_display').classList.remove('active');
  document.body.classList.remove('popup-error');
});

  document.querySelectorAll('[cart-var-id]').forEach(elm => {
  const varIds = elm.getAttribute('cart-var-id');
  const sections = elm.getAttribute('cart-section') || '';

  alertVariant(varIds, sections, 'https://roollapius.korres.com');


});

      document.querySelectorAll('[mcart-var-id]').forEach(elmm => {
  const varIds = elmm.getAttribute('mcart-var-id');
  const sections = elmm.getAttribute('cart-section') || '';

  alertVariant(varIds, sections, 'https://roollapius.korres.com');


});

const drawerItemsGiftd = Array.from(document.querySelectorAll('[cart-section="drawergift"]'));
const drawerItemsGiftod = Array.from(document.querySelectorAll('[cart-section="drawerordered"]'));
const giftInputd = document.querySelector('#master-free-gift');











if (giftInputd) {
  const giftProductIdd = giftInputd.getAttribute('date-productid'); // multiple triggering product IDs
  const giftVarIdd = giftInputd.getAttribute('data-giftid'); // gift variant ID
  const startDated = parseInt(giftInputd.dataset.startdate, 10);
  const endDated = parseInt(giftInputd.dataset.enddate, 10);
  const currentDated = parseInt(giftInputd.dataset.currentdate, 10);

  // Create a clean array of triggering product IDs
  const productIdListd = giftProductIdd.split(',').map(id => id.trim()).filter(Boolean);

  // Check if any triggering product is in the ordered section
  const matchedItemo = drawerItemsGiftod.find(item => {
    const cartVarId = item.getAttribute('cart-var-id');
    return productIdListd.includes(cartVarId);
  });















  // ✅ CASE 1: If within date range
  if (currentDated >= startDated && currentDated <= endDated) {

    const giftExistsod = drawerItemsGiftd.some(item => item.getAttribute('cart-var-id') === giftVarIdd);

    if (!giftExistsod && matchedItemo) {
      // ➕ Add gift to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: giftVarIdd,
            quantity: 1,
            properties: {
              "customprice": 0,
              "product_type": "Gift"
            }
          }]
        })
      })
      .then(res => res.json())
      .then(data => {
        console.log('Gift added to cart with properties:', data);
        location.reload(); // Optional
      })
      .catch(err => {
        console.error('Error adding gift to cart:', err);
      });
    }

  // 🚫 CASE 2: Outside date range — remove gift if it exists
  } else {
    const giftExistsd = drawerItemsGiftd.some(item => item.getAttribute('cart-var-id') === giftVarIdd);

    if (giftExistsd) {
      const giftRemoveButtond = document.querySelector(`cart-remove-button[cart-remove-id="${giftVarIdd}"]`);

      if (giftRemoveButtond) {
        const anchord = giftRemoveButtond.querySelector('a[href*="/cart/change?id="]');
        
        if (anchord) {
          const hrefd = anchord.getAttribute('href');

          fetch(hrefd)
            .then(response => {
              if (!response.ok) throw new Error('Failed to remove product from cart');
              location.reload(); // Optional
            })
            .catch(error => {
              console.error('Fetch error:', error);
            });
        }
      }
    }
  }
}



function shipData() {
setTimeout(function () {
 
  var today = new Date();
  var formattedDate = today.toISOString().split('T')[0];
  var orderTotal = parseFloat(document.getElementById('komt').textContent.trim());
  if (isNaN(orderTotal)) {
  orderTotal = parseFloat(document.getElementById('mkomt').textContent.trim());
}
  var factor = parseFloat(document.getElementById('kcmf').textContent.trim());
  if (isNaN(factor)) {
  factor = parseFloat(document.getElementById('mkcmf').textContent.trim());
}
    var khazVal = parseInt(document.getElementById('khaz').textContent.trim());
    if (isNaN(khazVal)) {
  khazVal = parseFloat(document.getElementById('mkhaz').textContent.trim());
}

  var requestOptionship = {
    method: 'GET',
    redirect: 'follow'
  };
  fetch("https://roollapius.korres.com/api/v1/MarketplaceItem/GetShippingCost?date=" + formattedDate + "&price=" + orderTotal + "&circle_id=" + factor, requestOptionship)
    .then((res) => res.json())
    .then((res) => {
      if (res && res.data && res.data.length > 0 && res.data[0].hasOwnProperty('shippingcost')) {
        var shippingrate;
        
  if (khazVal > 0) {
          shippingrate = res.data[0].extracharges * 100;
        } else {
          shippingrate = res.data[0].shippingcost * 100;
        }
    
  updateShippingRate(shippingrate.toString(), function (updatedCart) {
    console.log("Shipping rate:", shippingrate);
        });
      }
    });
  }, 100);
}


function updateShippingRate(newRate, callback) {
fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    let itemToUpdate = cart.items.find(item => item.properties && item.properties.shippingrate !== undefined);

    // If not found, use the first item
    if (!itemToUpdate && cart.items.length > 0) {
      itemToUpdate = cart.items[0];
      itemToUpdate.properties = itemToUpdate.properties || {};
    } else if (!itemToUpdate) {
      console.warn("Cart is empty. No item to update.");
      return;
    }

    // Clean properties and add/update shippingrate
    const cleanedProperties = {};
    for (let key in itemToUpdate.properties) {
      const value = itemToUpdate.properties[key];
      if (value !== null && value !== undefined && value !== '') {
        cleanedProperties[key] = value;
      }
    }
    //cleanedProperties.shippingrate = newRate;



// new changes addded 




// Gift update on cart
if (typeof gwpRunning !== 'undefined' && gwpRunning) {
  console.log('⏳ Waiting for GWP to finish...');

  return new Promise(resolve => {
    const check = setInterval(() => {
      if (!gwpRunning) {
        clearInterval(check);
        setTimeout(() => {
          resolve(fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: itemToUpdate.key,
              quantity: itemToUpdate.quantity,
              properties: cleanedProperties
            })
          }));
        }, 300);
      }
    }, 100);
  });
}

// new changes addded 


    // Update the item in-place using /cart/change.js
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: itemToUpdate.key,
        quantity: itemToUpdate.quantity,
        properties: cleanedProperties
      })
    });
  })


  
  .then(res => res.json())
  // .then(res => res ? res.json() : null)


  .then(updatedCart => {
    console.log('Updated cart:', updatedCart);

    // Update cart note
    const kclEl = document.getElementById('kcl');
    const kcfEl = document.getElementById('kcf');
    if (kclEl && kcfEl) {
      const kclValue = parseInt(kclEl.textContent.trim(), 10);
      let noteText = kclValue > 0
        ? "Multipler: " + kcfEl.textContent.trim()
        : "Multipler: guest";

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: noteText })
      })
      .then(() => console.log('Cart note updated.'))
      .catch(err => console.error('Failed to update cart note:', err));
    }
 if (window.location.pathname === '/pages/update-shipping') {
window.location.href = "/checkout";
 }
    document.body.classList.remove('checkout_btn_load');
    const checkoutBtnr = document.querySelector('.checkout_btn');

    if (typeof callback === 'function') callback(updatedCart);
  })
  .catch(err => console.error('Error updating cart item:', err));

}

shipData();
